// extracted by mini-css-extract-plugin
export default {"desktopTimeToDestination":"RouteView_desktopTimeToDestination__7XQ7c","snackBar":"RouteView_snackBar__OZdAF","snackContainer":"RouteView_snackContainer__w+3Ti"};